<template>
    <div>
        <b-row>
            <b-col md="6" class="my-1">
                <h3 class="text-themecolor"> {{$t('management.overhetbedrijf')}}</h3>
            </b-col>
            <b-col md="6" class="my-1">
                <div class="pull-right">
                    <b-button size="sm" @click.stop="goTo('update')" variant="themecolor" class="mr-1">
                        <i class="fa fa-edit" aria-hidden="true"></i>  {{$t('buttons.bewerken')}}
                    </b-button>
                    <delete title="Bedrijf" :id="company.id" namespace="management" resource="companies" />
                </div>
            </b-col>
        </b-row>
        <b-row>
            <b-col lg="4" xlg="3" md="4">
                <div class="card">
                    <div class="card-body">
                        <div v-if="company.id">
                            <center class="m-t-30">
                                <h4 class="card-title m-t-10">{{company.name}}</h4>
                                <h6 class="card-subtitle">{{company.domainName}}</h6>
                            </center>
                            <hr> 
                            <small class="text-muted"> {{$t('datatables.naam')}}</small>
                            <h6>{{company.name}}</h6>
                            <small class="text-muted"> {{$t('datatables.domeinnaam')}}</small>
                            <h6>{{company.domainName}}</h6>
                            <small class="text-muted"> {{$t('management.primarelatienummer')}}</small>
                            <h6>{{company.primaRelatienummer ? company.primaRelatienummer : '-'}}</h6>
                            <small class="text-muted"> {{$t('datatables.actief')}}</small>
                            <h6>{{company.active ?  $t('releases.ja') : $t('releases.nee')}}</h6>
                        </div>
                        <div v-else>
                            <content-placeholders>
                                <content-placeholders-heading />
                                <content-placeholders-text :lines="2" />
                                <content-placeholders-heading />
                                <content-placeholders-text :lines="2" />
                            </content-placeholders>
                        </div>
                    </div>
                </div>
            </b-col>
            
            <b-col lg="8" xlg="9" md="8">
                <div class="card">
                    <ul class="nav nav-tabs profile-tab" role="tablist">
                        <li class="nav-item">
                            <router-link :to="{ name: 'companies:detail:administrations' }" class="nav-link" data-toggle="tab" role="tab" aria-expanded="false">
                                 {{$t('management.administraties')}}
                            </router-link>
                        </li>
                        <li class="nav-item">
                            <router-link :to="{ name: 'companies:detail:users' }" class="nav-link" data-toggle="tab" role="tab" aria-expanded="false">
                                 {{$t('sidebar.gebruikers')}}
                            </router-link>
                        </li>
                        <li class="nav-item">
                            <router-link :to="{ name: 'companies:detail:modules' }" class="nav-link" data-toggle="tab" role="tab" aria-expanded="false">
                                 {{$t('sidebar.modules')}}
                            </router-link>
                        </li>
                    </ul>
                    <div class="tab-content">
                        <div class="tab-pane active" role="tabpanel">
                            <!-- Tabs, lazy loading -->
                            <router-view />
                        </div>
                    </div>
                </div>
            </b-col>
        </b-row>
        <b-row>
            <b-col md="12">
                <b-button @click="goTo('index')" variant="secondary"> {{$t('buttons.terugnaaroverzicht')}}</b-button>
            </b-col>
        </b-row>
    </div>
</template>
<script>
//Import store
import { mapGetters, mapActions } from 'vuex'

export default {
    name: 'companies-detail',
    computed: {
        ...mapGetters('management',['company']),
    },
    methods: {
        ...mapActions('management',['find']),
        goTo(name) {
            var vm = this;
            vm.$router.push({ name: `companies:${name}` });
        }
    },
    created() {
        var vm = this;
        
        vm.find({
            resource: 'companies',
            id: vm.$route.params.companyId
        });
    }
}
</script>